import React, { Component } from 'react';

class PixelSelector extends Component {
	static pixels = [1, 2, 3, 4, 5, 6, 7, 8, 9];
	render() {
		return (
			<select
				onChange={(e) => this.props.callback(e.target.value)}
				defaultValue={this.props.pixels}
			>
				{
					PixelSelector.pixels.map((pixels) => {
						return (
							<option
								key={pixels}
								value={pixels}
							>{pixels} {pixels === 1 ? "pixel" : "pixels"}
							</option>
						)
					})
				}
			</select>
		);
	}
}

export default PixelSelector;